/** API route map: URLS.Controller.BillingFormat */
export const BillingFormat = {
      Name: 'BillingFormat/',
      GetAllBillingFormat: 'get-all',
      AddBillingFormat: 'add',
      UpdateBillingFormat: 'update',
      DeleteBillingFormat: 'delete',
};
